import HPreviewImage from './HPreviewImage.vue'

// 为组件提供 install 安装方法，供按需引入
HPreviewImage.install = function (Vue) {
    Vue.component(HPreviewImage.name, HPreviewImage)
}
  
// 默认导出组件
export default HPreviewImage